import { FetchError } from 'ofetch';

export default (error: unknown): error is FetchError => error instanceof FetchError;
